import contentManagerV3 from "./contentManagerV3";

/**
 * Generate breadcrumb items for support pages
 *
 * @param {string} currentPath - Current page path
 * @param {Object} article - Article object (optional)
 * @returns {Array} Array of breadcrumb items
 */
export const generateSupportBreadcrumbs = (currentPath, article = null) => {
  const breadcrumbs = [
    {
      label: "Support",
      path: "/support",
    },
  ];

  // Handle different support page paths
  if (currentPath === "/support") {
    return breadcrumbs;
  }

  // Handle article paths
  if (article) {
    const category = contentManagerV3.getCategoryById(article.category);

    if (category) {
      breadcrumbs.push({
        label: category.title,
        path: `/support#${category.id}`,
      });
    }

    breadcrumbs.push({
      label: article.title,
      path: article.path,
    });
  } else {
    // Handle specific support page paths
    const pathSegments = currentPath.split("/").filter(Boolean);

    if (pathSegments.length >= 2) {
      const categoryId = pathSegments[1];
      const category = contentManagerV3.getCategoryById(categoryId);

      if (category) {
        breadcrumbs.push({
          label: category.title,
          path: `/support#${categoryId}`,
        });
      }
    }
  }

  return breadcrumbs;
};

/**
 * Generate breadcrumbs for specific support sections
 */
export const supportBreadcrumbHelpers = {
  // FAQ breadcrumbs
  faq: () => [
    { label: "Support", path: "/support" },
    {
      label: "Frequently Asked Questions",
      path: "/support/faqs",
    },
  ],

  // Tutorial breadcrumbs
  tutorial: (categoryId, articleTitle) => {
    const category = contentManagerV3.getCategoryById(categoryId);
    const breadcrumbs = [{ label: "Support", path: "/support" }];

    if (category) {
      breadcrumbs.push({
        label: category.title,
        path: `/support#${categoryId}`,
      });
    }

    if (articleTitle) {
      breadcrumbs.push({
        label: articleTitle,
      });
    }

    return breadcrumbs;
  },

  // Category breadcrumbs
  category: (categoryId) => {
    const category = contentManagerV3.getCategoryById(categoryId);
    return [
      { label: "Support", path: "/support" },
      {
        label: category?.title || "Category",
        path: `/support#${categoryId}`,
      },
    ];
  },
};

const supportBreadcrumbs = {
  generateSupportBreadcrumbs,
  supportBreadcrumbHelpers,
};

export default supportBreadcrumbs;
